import StatusCard from '@/components/StatusCard';

/**
 * The router's errorElement — something threw while rendering a route. Same card as every
 * other dead end (StatusCard). "Go to Home" is '/', which is public and routes by
 * permission, rather than a specific app the user may not have.
 */
export default function ServerError() {
  return (
    <StatusCard
      title="Something Went Wrong"
      message={
        <>
          We&apos;re sorry, something went wrong on our end.
          <br />
          Try again, or contact your system administrator if it keeps happening.
        </>
      }
      actions={[
        { label: 'Try Again', onClick: () => window.location.reload() },
        { label: 'Go to Home', href: '/', variant: 'secondary' },
      ]}
    />
  );
}
